import * as core from '../../../../../../../core'

import { query } from './delete-proposal-domain-row.query'

export const RESOURCE = {
  payload: {
    alias: 'delete.proposal.domain.row',
    description:
      'Deletes a proposal-domain row from the proposal-domain row edit modal',
    name: 'Delete Proposal Domain Row',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
